module.exports = __webpack_public_path__ + "static/340FFF_5_0-c090ee2f176a46e1f857fe32023b45c8.woff2";